import { Box, MenuItem, TextField, Button, InputLabel, FormControl, Typography, Table, TableCell, Paper, TableRow, TableBody, TableContainer, TableHead, Chip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Tooltip } from "@mui/material";
import Header from "../../../../components/Header";
import useAuth from "../../../../auth/useAuth";
import useMediaQuery from "@mui/material/useMediaQuery";
import Select from '@mui/material/Select';
import swal from "sweetalert";
import { useEffect, useState } from "react";
import FatalError from "../../../global/FatalError";
import Loading from "../../../global/Loading";
import { useFetchGET } from "../../../../state/FetchHelpers";
import { usersByRolRoute, getCashBalanceByUser } from "../../../../config";
import { useFormik } from "formik";
import { useSearchParams } from "react-router-dom";
import CierreRutaCashSection from "./CierreRutaCashSection";
import { useRouteClosure } from "../../../hooks/route/useRouteClosure.tsx";
import { useExpenseManager } from "../../../hooks/expense/useExpenseManager.tsx";

const CierreRuta = ({permissionsListData}) => {
  const auth = useAuth();
  const token = auth.globals.token;
  const [searchParams] = useSearchParams();
  const prevDate = searchParams.get("date");
  const prevDriverId = searchParams.get("driver");
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [errorRequest, setErrorRequest] = useState(null);
  const [record, setRecord] = useState([]);
  const [recordPickup, setRecordPickup] = useState([]);
  const [recordExpenses, setRecordExpenses] = useState([]);
  const [recordCash, setRecordCash] = useState([]);
  const [totalDeliveryCash, setTotalDeliveryCash] = useState(0);
  const [totalPickupCash, setTotalPickupCash] = useState(0);
  const [totalDeliveryTransfer, setTotalDeliveryTransfer] = useState(0);
  const [totalPickupTransfer, setTotalPickupTransfer] = useState(0);
  const [totalDeliveryCheck, setTotalDeliveryCheck] = useState(0);
  const [totalPickupCheck, setTotalPickupCheck] = useState(0);
  const [totalDeliveryPayed, setTotalDeliveryPayed] = useState(0);
  const [totalPickupPayed, setTotalPickupPayed] = useState(0);
  const [totalDeliveryCost, setTotalDeliveryCost] = useState(0);
  const [totalPickupCost, setTotalPickupCost] = useState(0);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [totalCash, setTotalCash] = useState(0);
  const [cashLoadWarning, setCashLoadWarning] = useState("");
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [showInformation, setShowInformation] = useState(false);
  const [reasonDialog, setReasonDialog] = useState(null);
  const total = isNaN((totalDeliveryCash + totalPickupCash) - totalExpenses) ? 0 : (totalDeliveryCash + totalPickupCash) - totalExpenses - totalCash;

  const { data: usersListData, loading: usersListLoading, error: usersListError } = useFetchGET(usersByRolRoute(2), token, []);

  const {
    obtainDetailClosureDelivery,
    obtainDetailClosurePickup
  } = useRouteClosure();
  
  const getDetailClosureDelivery = async (date, user_driver) => {
    setLoadingRequest(true)
    const data = await obtainDetailClosureDelivery(date, user_driver, setErrorRequest);
    setLoadingRequest(false)
    if (data === undefined) {
      setRecord(null);
    } else {
      setTotalDeliveryCash(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.cash)) ? 0 : parseFloat(item.cash)), 0));
      setTotalDeliveryTransfer(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.transfer)) ? 0 : parseFloat(item.transfer)), 0));
      setTotalDeliveryCheck(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.cheque)) ? 0 : parseFloat(item.cheque)), 0));
      setTotalDeliveryPayed(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.payed)) ? 0 : parseFloat(item.payed)), 0));
      setTotalDeliveryCost(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.delivery_cost)) ? 0 : parseFloat(item.delivery_cost)), 0));
      setRecord(Array.isArray(data) ? data : [])
    }
  }

  const getDetailClosurePickup = async (date, user_driver) => {
    setLoadingRequest(true)
    const data = await obtainDetailClosurePickup(date, user_driver, setErrorRequest);
    setLoadingRequest(false)
    if (data === undefined) {
      setRecord(null);
    } else {
      setTotalPickupCash(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.cash)) ? 0 : parseFloat(item.cash)), 0));
      setTotalPickupTransfer(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.transfer)) ? 0 : parseFloat(item.transfer)), 0));
      setTotalPickupCheck(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.cheque)) ? 0 : parseFloat(item.cheque)), 0));
      setTotalPickupPayed(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.payed)) ? 0 : parseFloat(item.payed)), 0));
      setTotalPickupCost(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.delivery_cost)) ? 0 : parseFloat(item.delivery_cost)), 0));
      setRecordPickup(Array.isArray(data) ? data : [])
    }
  }

  const {
      getDetailExpensesByDateAndUser,
    } = useExpenseManager();
  
    const getDetailExpenses = async (date, user_driver) => {
      setLoadingRequest(true)
      const data = await getDetailExpensesByDateAndUser(date, user_driver);
      setLoadingRequest(false)
      if (data === undefined) {
        setRecordExpenses([]);
        setErrorRequest(true);
        setRecord(null)
      } else {
        setTotalExpenses(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.amount)) ? 0 : parseFloat(item.amount)), 0));
        setRecordExpenses(Array.isArray(data) ? data : []);
      }
    }

  const getDetailCashEntries = async (date, user_driver) => {
    if (! date) {
      console.warn('Date is required for getting cash entries');
      return;
    }
    try {
      setLoadingRequest(true);
      const response = await getCashBalanceByUser(token, user_driver, date);
      setLoadingRequest(false);
      if (response.ok) {
        const data = await response.json();
        setCashLoadWarning("");
        setTotalCash(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.amount)) ? 0 : parseFloat(item.amount)), 0));
        setRecordCash(Array.isArray(data) ? data : []);
        return data;
      }
      if (response.status === 404) {
        setCashLoadWarning("No se pudo cargar el efectivo recibido");
        setTotalCash(0);
        setRecordCash([]);
        return [];
      }
      if (response.status === 401 || response.status === 403) {
        showErrorAlert("No tiene autorización o su sesión ha expirado");
        return undefined;
      }
      setCashLoadWarning("No se pudo cargar el efectivo recibido");
      setTotalCash(0);
      setRecordCash([]);
    } catch (errorRequest) {
      setLoadingRequest(false)
      setErrorRequest(errorRequest)
    }
  }

  const performDataSearch = (values) => {
    try {
      setLoadingRequest(true);
      setShowInformation(true);
      setCashLoadWarning("");
      getDetailClosureDelivery(values.date, values.user_driver);
      getDetailClosurePickup(values.date, values.user_driver);
      getDetailExpenses(values.date, values.user_driver);
      getDetailCashEntries(values.date, values.user_driver);
    } catch (error) {
      //console.log(error);
    }
  }

  const updateOnlyCashEntries = () => {
    try {
      getDetailCashEntries(searchFormik.values.date, searchFormik.values.user_driver);
    } catch (error) {
      console.error('Error updating cash-entries');
    }
  }


  const searchFormik = useFormik({
    initialValues: {
      date: prevDate || '',
      user_driver: prevDriverId || ''
    },
    onSubmit: performDataSearch
  });

  useEffect(() => {
    if (prevDate && prevDriverId) {
      performDataSearch({date:prevDate, user_driver:prevDriverId});
    }
  }, [prevDate, prevDriverId])


  // ---------------------------------------------------------- ALERTS ----------------------------------------------------------------------------
  const showErrorAlert = (error) => {
    if (error != null) {
      try {
        swal({
          title: "Error",
          text: "Resultado: " + error,
          icon: "error",
          button: "Aceptar"
        })
        if (error === "No tiene autorización o su sesión ha expirado") {
          auth.logout();
        }
      } catch (e) {
        swal({
          title: "Error",
          text: "Error inesperado ",
          icon: "error",
          button: "Aceptar"
        })
      }
    }
    setErrorRequest(null)
  }

  if (usersListLoading || loadingRequest)
    return (<Loading />)

  if (usersListError || errorRequest)
    return (<FatalError />)

  return (
    <Box m="20px" marginBottom="64px">
      <Header title="Cierre de ruta" subtitle="Cierre de ruta"  />

      { showInformation && (<Header title={`Líquido a recibir: ${total}`}  /> )}

      <form onSubmit={searchFormik.handleSubmit}>
        <Box display="grid"
          gap="15px"
          marginBottom="15px"
          gridTemplateColumns="repeat(12, minmax(0, 1fr))"
          sx={{
            "& > div": { gridColumn: isNonMobile ? undefined : "span 12" }
          }} >

          <TextField
            disabled={false}
            fullWidth={!isNonMobile}
            variant="filled"
            type="date"
            label="Fecha"
            asp-format="{0:yyyy-MM-dd}"
            name="date"
            value={searchFormik.values.date}
            onChange={searchFormik.handleChange}
            size="small"
            sx={{ gridColumn: "span 3" }}
            required
          />

          <FormControl variant="filled"
            disabled={false}
            sx={{ gridColumn: "span 5" }}
            required>
            <InputLabel id="select-driver-label" name="select-driver-label">Driver asignado</InputLabel>
            <Select
              labelId="select-driver-label"
              id="select-driver"
              fullWidth={!isNonMobile}
              name="user_driver"
              size="small"
              value={searchFormik.values.user_driver}
              onChange={searchFormik.handleChange}
            >

              {usersListData.map((user) => (
                (permissionsListData.includes(41)?
                  <MenuItem key={user.id} value={user.id.toString()}>
                    {user.name + ' ' + user.lastname}
                  </MenuItem>
                  :user.id === auth.globals.id?
                  <MenuItem key={user.id} value={user.id.toString()}>
                    {user.name + ' ' + user.lastname}
                  </MenuItem>
                :undefined)
              ))}
            </Select>
          </FormControl>

          <Button type="submit" variant="contained" color="secondary">
            Mostrar
          </Button>
        </Box>
      </form>

      { showInformation && permissionsListData.includes(17) &&
         <CierreRutaCashSection
          recordCash={recordCash}
          totalCash={totalCash}
          warningMessage={cashLoadWarning}
          maxTotalBalance={total}
          requireUpdateUI={updateOnlyCashEntries}
          selectedDate={searchFormik.values.date}
          selectedDriver={searchFormik.values.user_driver}>
        </CierreRutaCashSection> }

      { showInformation && (
      <Box sx={{ marginTop: 2 }}>
        <Typography variant="h5" sx={{ marginBottom: 2, fontWeight: 'bold'  }}> Ingresos </Typography>
        <TableContainer component={Paper} sx={{ maxHeight: '80vh', overflow: 'auto' }}>
          <Table>
            <TableHead sx={{ position: 'sticky', top: 0, backgroundColor: 'background.paper', zIndex: 1 }}>
              <TableRow>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>ID</TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Empresa</TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Nombre del cliente&nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Teléfono del cliente&nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>País&nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Ruta&nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Estado de registro &nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Estatus de orden &nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Pagado hasta el momento &nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Cobrado por el driver (efectivo) &nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Transferido&nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Zelle / Tarjeta&nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Cheque&nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Pagado&nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}> Monto a cobrar &nbsp; </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell colSpan={14} style={{ fontWeight: 'bold' }}> Delivery </TableCell>
              </TableRow>
              {
                record && record.map((item) =>
                  <TableRow key={item.id}>
                    <TableCell align="right">{item.correlative}</TableCell>
                    <TableCell align="right">{item.company}</TableCell>
                    <TableCell align="right">{item.senders_name}</TableCell>
                    <TableCell align="right">{item.senders_phone}</TableCell>
                    <TableCell align="right">{item.name}</TableCell>
                    <TableCell align="right">{item.route_name}</TableCell>
                    <TableCell
                      style={{
                        fontWeight: 'bold',
                        color: item.record_status === 'ACTIVO' ? 'green' : 'red',
                      }}
                    >
                      {item.record_status === 'ACTIVO' ? 'ACTIVO' : 'ANULADO'}
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{
                        fontWeight: 'bold',
                        color:
                          item.record_status !== 'ACTIVO'
                            ? 'inherit'
                            : !(item.has_payment_record ?? (item.total_payed != null))
                              ? item.reassigned
                                ? 'blue'
                                : 'gray'
                              : (item.delivery_cost ?? 0) - (item.payed ?? 0) <= 0
                                ? 'green'
                                : item.reassigned
                                  ? 'blue'
                                  : (item.total_payed === 0 || item.total_payed === null)
                                    ? '#1976d2'
                                    : 'orange',
                      }}
                    >
                      { item.record_status !== 'ACTIVO'
                          ? ""
                          : item.status === 1
                            ? !(item.has_payment_record ?? (item.total_payed != null))
                                ? item.reassigned && !item.has_driver_action
                                    ? "Reprogramado"
                                    : item.reported_by_driver
                                        ? (<><span>No visitado</span><br /><Chip label="Piloto avisó" size="small" color="warning" onClick={(e) => { e.stopPropagation(); setReasonDialog(item.driver_report_reason || 'Sin motivo registrado'); }} sx={{ fontSize: '0.65rem', height: '18px', mt: 0.3, cursor: 'pointer' }} /></>)
                                        : "No visitado"
                                : (item.delivery_cost ?? 0) - (item.payed ?? 0) <= 0
                                  ? "Pago completado"
                                  : item.reassigned && !item.has_driver_action
                                    ? "Reprogramado"
                                    : (item.payed ?? 0) > 0 || item.has_driver_action
                                      ? "Pago en país destino"
                                      : "Con saldo"
                            : !(item.has_payment_record ?? (item.total_payed != null))
                                ? item.reassigned && !item.has_driver_action
                                    ? "Reprogramado"
                                    : item.reported_by_driver
                                        ? (<><span>No visitado</span><br /><Chip label="Piloto avisó" size="small" color="warning" onClick={(e) => { e.stopPropagation(); setReasonDialog(item.driver_report_reason || 'Sin motivo registrado'); }} sx={{ fontSize: '0.65rem', height: '18px', mt: 0.3, cursor: 'pointer' }} /></>)
                                        : "No visitado"
                                : (item.delivery_cost ?? 0) - (item.payed ?? 0) <= 0
                                  ? "Pago completado"
                                  : item.reassigned && !item.has_driver_action
                                    ? "Reprogramado"
                                    : (item.payed ?? 0) > 0 || item.has_driver_action
                                      ? "Pago en país destino"
                                      : "Con saldo"
                      }
                    </TableCell>
                    <TableCell align="right">{item.total_payed}</TableCell>
                    <TableCell align="right" style={{ fontWeight: 'bold' }}>{item.cash ?? '$0'}</TableCell>
                    <TableCell align="right">{item.transfer}</TableCell>
                    <Tooltip title={`Zelle: $${item.transfer ?? 0} / Tarjeta: $${item.credit_card ?? 0}`}>
                      <TableCell align="right">
                        {(item.transfer ?? 0) + (item.credit_card ?? 0) > 0 ? `$${(item.transfer ?? 0) + (item.credit_card ?? 0)}` : ''}
                      </TableCell>
                    </Tooltip>
                    <TableCell align="right">{item.cheque}</TableCell>
                    <TableCell align="right">{item.payed}</TableCell>
                    <TableCell align="right">{item.delivery_cost}</TableCell>
                  </TableRow>
                )
              }
              <TableRow>
                <TableCell colSpan={8}/>
                <TableCell align="right" style={{ fontWeight: 'bold' }}> Total </TableCell>
                <TableCell align="right" style={{ fontWeight: 'bold' }}> {totalDeliveryCash} </TableCell>
                <TableCell align="right"> {totalDeliveryTransfer} </TableCell>
                <TableCell align="right"/>
                <TableCell align="right"> {totalDeliveryCheck} </TableCell>
                <TableCell align="right"> {totalDeliveryPayed} </TableCell>
                <TableCell align="right"> {totalDeliveryCost} </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={14} style={{ fontWeight: 'bold' }}> Pickup </TableCell>
              </TableRow>
              {
                recordPickup && recordPickup.map((item) =>
                  <TableRow key={item.id}>
                    <TableCell align="right">{item.correlative}</TableCell>
                    <TableCell align="right">{item.company}</TableCell>
                    <TableCell align="right">{item.senders_name}</TableCell>
                    <TableCell align="right">{item.senders_phone}</TableCell>
                    <TableCell align="right">{item.name}</TableCell>
                    <TableCell align="right">{item.route_name}</TableCell>
                    <TableCell
                      style={{
                        fontWeight: 'bold',
                        color: item.record_status === 'ACTIVO' ? 'green' : 'red',
                      }}
                    >
                      {item.record_status === 'ACTIVO' ? 'ACTIVO' : 'ANULADO'}
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{
                        fontWeight: 'bold',
                        color:
                          item.record_status !== 'ACTIVO'
                            ? 'inherit'
                            : !(item.has_payment_record ?? (item.total_payed != null))
                              ? item.reassigned
                                ? 'blue'
                                : 'gray'
                              : (item.delivery_cost ?? 0) - (item.payed ?? 0) <= 0
                                ? 'green'
                                : item.reassigned
                                  ? 'blue'
                                  : (item.total_payed === 0 || item.total_payed === null)
                                    ? '#1976d2'
                                    : 'orange',
                      }}
                    >
                      { item.record_status !== 'ACTIVO'
                          ? ""
                          : item.status === 1
                            ? !(item.has_payment_record ?? (item.total_payed != null))
                                ? item.reassigned && !item.has_driver_action
                                    ? "Reprogramado"
                                    : item.reported_by_driver
                                        ? (<><span>No visitado</span><br /><Chip label="Piloto avisó" size="small" color="warning" onClick={(e) => { e.stopPropagation(); setReasonDialog(item.driver_report_reason || 'Sin motivo registrado'); }} sx={{ fontSize: '0.65rem', height: '18px', mt: 0.3, cursor: 'pointer' }} /></>)
                                        : "No visitado"
                                : (item.delivery_cost ?? 0) - (item.payed ?? 0) <= 0
                                  ? "Pago completado"
                                  : item.reassigned && !item.has_driver_action
                                    ? "Reprogramado"
                                    : (item.payed ?? 0) > 0 || item.has_driver_action
                                      ? "Pago en país destino"
                                      : "Con saldo"
                            : !(item.has_payment_record ?? (item.total_payed != null))
                                ? item.reassigned && !item.has_driver_action
                                    ? "Reprogramado"
                                    : item.reported_by_driver
                                        ? (<><span>No visitado</span><br /><Chip label="Piloto avisó" size="small" color="warning" onClick={(e) => { e.stopPropagation(); setReasonDialog(item.driver_report_reason || 'Sin motivo registrado'); }} sx={{ fontSize: '0.65rem', height: '18px', mt: 0.3, cursor: 'pointer' }} /></>)
                                        : "No visitado"
                                : (item.delivery_cost ?? 0) - (item.payed ?? 0) <= 0
                                  ? "Pago completado"
                                  : item.reassigned && !item.has_driver_action
                                    ? "Reprogramado"
                                    : (item.payed ?? 0) > 0 || item.has_driver_action
                                      ? "Pago en país destino"
                                      : "Con saldo"
                      }
                    </TableCell>
                    <TableCell align="right">{item.total_payed}</TableCell>
                    <TableCell align="right" style={{ fontWeight: 'bold' }}>{item.cash ?? '$0'}</TableCell>
                    <TableCell align="right">{item.transfer}</TableCell>
                    <Tooltip title={`Zelle: $${item.transfer ?? 0} / Tarjeta: $${item.credit_card ?? 0}`}>
                      <TableCell align="right">
                        {(item.transfer ?? 0) + (item.credit_card ?? 0) > 0 ? `$${(item.transfer ?? 0) + (item.credit_card ?? 0)}` : ''}
                      </TableCell>
                    </Tooltip>
                    <TableCell align="right">{item.cheque}</TableCell>
                    <TableCell align="right">{item.payed}</TableCell>
                    <TableCell align="right">{item.delivery_cost}</TableCell>
                  </TableRow>
                )
              }
              <TableRow>
                <TableCell colSpan={8}/>
                <TableCell align="right" style={{ fontWeight: 'bold' }}> Total </TableCell>
                <TableCell align="right" style={{ fontWeight: 'bold' }}> {totalPickupCash} </TableCell>
                <TableCell align="right"> {totalPickupTransfer} </TableCell>
                <TableCell align="right"/>
                <TableCell align="right"> {totalPickupCheck} </TableCell>
                <TableCell align="right"> {totalPickupPayed} </TableCell>
                <TableCell align="right"> {totalPickupCost} </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      )}

      { showInformation && (
      <Box sx={{ marginTop: 2 }}>
        <Typography variant="h5" sx={{ marginBottom: 2, fontWeight: 'bold'  }}> Gastos </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}>Categoría de gasto </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}> Tipo de gasto &nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}> Monto &nbsp; </TableCell>
                <TableCell align="right" component="th" style={{ fontWeight: 'bold' }}> Descripción &nbsp; </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            { recordExpenses && recordExpenses.map((item) =>
              <TableRow key={item.id}>
                <TableCell align="right">{item.category}</TableCell>
                <TableCell align="right">{item.fee_type}</TableCell>
                <TableCell align="right">{item.amount}</TableCell>
                <TableCell align="right">{item.fee_description}</TableCell>
              </TableRow> )}

              <TableRow>
                <TableCell />
                <TableCell align="right" style={{ fontWeight: 'bold' }}> Total </TableCell>
                <TableCell align="right" style={{ fontWeight: 'bold' }}> {totalExpenses} </TableCell>
                <TableCell />
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box> )}

      <Dialog open={reasonDialog !== null} onClose={() => setReasonDialog(null)} maxWidth="sm" fullWidth>
        <DialogTitle>Reporte del piloto</DialogTitle>
        <DialogContent>
          <DialogContentText>{reasonDialog}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setReasonDialog(null)} color="inherit">Cerrar</Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
}

export default CierreRuta;
